"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotBalancesTable = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Table = require("../../data/table/Table");
var _CryptoNavItemsContainer = _interopRequireDefault(require("../../WalletNavItems/CryptoNavItemsContainer"));
var _FiatNavItemsContainer = _interopRequireDefault(require("../../WalletNavItems/FiatNavItemsContainer"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _reactI18next = require("react-i18next");
var _ProductIconContainer = _interopRequireDefault(require("../../common/ProductIcon/ProductIconContainer"));
var _numberFormatter = require("../../../helpers/numberFormatter");
require("./BalancesTable.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var createCls = (0, _cssClassesHelper.getBEMClasses)('wallet-balances-table');
var SpotBalancesTable = exports.SpotBalancesTable = function SpotBalancesTable(_ref) {
  var products = _ref.products,
    loading = _ref.loading,
    notionalProduct = _ref.notionalProduct;
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  var formatValue = function formatValue(value) {
    if (value === '-') return 0;
    if (typeof value === 'string') return parseFloat(value.replace(/,/g, ''));
    return value;
  };
  var renderCell = (0, _react.useCallback)(function (value, notionalValue, decimalPlaces) {
    var formattedValue = formatValue(value);
    var formattedNotionalValue = formatValue(notionalValue);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: createCls('num-cell')
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: createCls('num-cell__value')
    }, (0, _numberFormatter.formatNumberToLocale)(formattedValue, decimalPlaces)), /*#__PURE__*/_react["default"].createElement("span", {
      className: createCls('num-cell__notional')
    }, (0, _numberFormatter.formatNumberToLocale)(formattedNotionalValue, notionalProduct.DecimalPlaces), /*#__PURE__*/_react["default"].createElement("span", {
      className: createCls('num-cell__symbol')
    }, notionalProduct.Product)));
  }, [notionalProduct]);
  var columns = (0, _react.useMemo)(function () {
    return [{
      header: t('Actions'),
      id: 'Actions',
      size: 168,
      minSize: 168,
      maxSize: 168,
      meta: {
        fixedWidth: true
      },
      className: 'actions',
      cell: function cell(_ref2) {
        var row = _ref2.row;
        var ActionsComponent = row.original.ProductType === 'CryptoCurrency' ? _CryptoNavItemsContainer["default"] : _FiatNavItemsContainer["default"];
        return /*#__PURE__*/_react["default"].createElement(ActionsComponent, {
          product: row.original,
          showIconButtonLabel: false,
          margin: false
        });
      }
    }, {
      header: t('Asset'),
      accessorKey: 'ProductFullName',
      enableSorting: true,
      cell: function cell(_ref3) {
        var row = _ref3.row;
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: createCls('cell-asset')
        }, /*#__PURE__*/_react["default"].createElement(_ProductIconContainer["default"], {
          iconFileName: row.original.iconFileName,
          size: 32
        }), /*#__PURE__*/_react["default"].createElement("span", {
          className: createCls('asset-symbol')
        }, row.original.ProductSymbol), /*#__PURE__*/_react["default"].createElement("span", {
          className: createCls('asset-name')
        }, row.original.ProductFullName));
      }
    }, {
      header: t('Total Balance'),
      accessorKey: 'NotionalValue',
      enableSorting: true,
      meta: {
        textAlign: 'right'
      },
      cell: function cell(_ref4) {
        var row = _ref4.row;
        return renderCell(row.original.Amount, row.original.NotionalValue, row.original.DecimalPlaces);
      }
    }, {
      header: t('Available Balance'),
      accessorKey: 'AvailableBalance',
      enableSorting: true,
      meta: {
        textAlign: 'right'
      },
      cell: function cell(_ref5) {
        var row = _ref5.row;
        return renderCell(row.original.AvailableBalance, row.original.AvailableBalanceNotional, row.original.DecimalPlaces);
      }
    }, {
      header: t('On Hold'),
      accessorKey: 'NotionalHoldAmount',
      enableSorting: true,
      meta: {
        textAlign: 'right'
      },
      cell: function cell(_ref6) {
        var row = _ref6.row;
        return renderCell(row.original.Hold, row.original.NotionalHoldAmount, row.original.DecimalPlaces);
      }
    }, {
      header: t('Pending Deposits'),
      accessorKey: 'PendingDeposits',
      enableSorting: true,
      meta: {
        textAlign: 'right'
      },
      cell: function cell(_ref7) {
        var row = _ref7.row;
        return renderCell(row.original.PendingDeposits, row.original.PendingDepositsNotional, row.original.DecimalPlaces);
      }
    }];
  }, [t, renderCell]);
  return /*#__PURE__*/_react["default"].createElement(_Table.Table, {
    data: products,
    columns: columns,
    loading: loading,
    stickyColumns: {
      left: ['Actions', 'ProductFullName']
    },
    className: createCls(),
    emptyMessage: t('No Spot Assets Found')
  });
};